import { render } from "./AsociarUsuNivFact.vue?vue&type=template&id=1c7c584e"
import script from "./AsociarUsuNivFact.vue?vue&type=script&lang=js"
export * from "./AsociarUsuNivFact.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__